module.exports = __webpack_public_path__ + "img/drag0.14b1a7df.svg";